export default "__VITE_ASSET__DO$mJm1r__"